export type LoggerEvent = {
    name: string
    experiment?: string
}

export function logEvent(event: LoggerEvent): void {
    const parts = event?.experiment?.split('|')
    const testId = parts?.[0] || ''
    const testGroupId = parts?.[1] || ''

    const eventsPayload = {
        events: [
            {
                target: 'voltax_recirculation',
                type: 'widget_group_of_links',
                version: '1.0',
                event: event.name,
                domain: typeof window !== 'undefined' ? window.location.hostname : '',
                path: typeof window !== 'undefined' ? window.location.href : '',
                testId,
                testGroupId,
            },
        ],
    }

    const url = 'https://eventer-widget.bqstreamer.com/tr'
    const payload = JSON.stringify(eventsPayload)

    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
        navigator.sendBeacon(url, payload)
    }
}
